import React from "react";

import SVGnumber from "./SVGnumber";

import "../styles/components/SectionAboutUs.css";

const SectionAboutUs = ({ version, data }) => {
  return (
    <section className="section__about-us">
      <div className="container container-small">
        {version === 1 && (
          <div className="version-1">
            <div className="row">
              <div className="col-12 col-lg-6 number-wrapper text-left title">
                <SVGnumber version={version} />
                <h4>{data.title}</h4>
              </div>
              <div className="col-12 col-lg-5 offset-lg-1 zindex-up padding-bottom-mobile">
                <span>{data.short_desc}</span>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 offset-md-0 col-lg-5 offset-lg-1">
                <img src={data.photo_url} alt={`About us section single element - ${version}`} />
              </div>
              <div className="col-12 col-ms-6 col-md-5 offset-md-1 col-lg-3 offset-lg-2 zindex-up">
                <div dangerouslySetInnerHTML={{ __html: data.long_desc }} />
              </div>
            </div>
          </div>
        )}
        {version === 2 && (
          <div className="version-2">
            <div className="row">
              <div className="col-6 col-md-5 display-desktop">
                <img src={data.photo_url} alt={`About us section single element - ${version}`} />
              </div>
              <div className="col-6 col-md-3 no-padding-right zindex-up display-desktop">
                <span>{data.short_desc}</span>
              </div>
              <div className="col-12 col-md-4 title padding-top zindex-up">
                <div className="number-wrapper title">
                  <SVGnumber version={version} />
                  <h4>{data.title}</h4>
                </div>
                <span
                  className={`display-mobile`}
                  style={{
                    width: "100%",
                    textAlign: "justify",
                    padding: "30px 0"
                  }}
                >
                  {data.short_desc}
                </span>
                <img
                  className={`display-mobile`}
                  style={{ paddingRight: 0 }}
                  src={data.photo_url}
                  alt={`About us section single element - ${version}`}
                />
                <div dangerouslySetInnerHTML={{ __html: data.long_desc }} />
              </div>
            </div>
          </div>
        )}
        {version === 3 && (
          <div className="version-3">
            <div className="row padding-bottom">
              <div className="col-12 col-md-7 number-wrapper title zindex-up">
                <SVGnumber version={version} />
                <h4>{data.title}</h4>
              </div>
              <div className="col-12 col-md-5 zindex-up">
                <span className="display-desktop">
                  <span>{data.short_desc}</span>
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 offset-md-1">
                <img src={data.photo_url} alt={`About us section single element - ${version}`} />
              </div>
              <div className="col-12 col-md-3 offset-md-1 no-padding-left zindex-up">
                <div dangerouslySetInnerHTML={{ __html: data.long_desc }} />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionAboutUs;
